import { render, staticRenderFns } from "./MyClass.vue?vue&type=template&id=f2179886&"
import script from "./MyClass.vue?vue&type=script&lang=js&"
export * from "./MyClass.vue?vue&type=script&lang=js&"
import style0 from "./MyClass.vue?vue&type=style&index=0&id=f2179886&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports